module.exports = __webpack_public_path__ + "static/media/gamepad.eaeefaaa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/gamepad.png
// module id = 2210
// module chunks = 0